export default __webpack_public_path__ + "static/media/portfolio-demo.e5552ed2.gif";